/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import {Input, Row, Col, Label, Alert} from 'reactstrap';
import Validator from '../../custom-classes/validator';
/** Multiple Language imports **/
import {Translate} from "react-localize-redux";
/** End of Multiple Language imports **/

/**
 * Handles the email, including validation with the server, and evaluates if it seems real or not.
 */
class FormGroupEmail extends React.Component {

    constructor(props) {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        this.state =
        {
            validEmail: true,
            emailAvailable: true,
            email: '',
            disabled: this.props.disabled,
            isForPasswordReset:
                typeof this.props.isForPasswordReset !== 'undefined' ? this.props.isForPasswordReset : false
        }; // Default value

        if (this.props.data) {
            this.state =
            {
                email: this.props.data.email,
                emailAvailable: true,
                validEmail: true,
                disabled: this.props.disabled
            }; // Default value
        }

        this.handleChange = this.handleChange.bind(this);
    }

    /**
     * If the props are not null, set the values
     * @param nextProps
     */
    componentWillReceiveProps(nextProps) {

        if (typeof nextProps.data !== 'undefined') {
            this.setState({
                email: nextProps.data.email,
                disabled: nextProps.disabled
            });
        }
    }

    /**
     * Action when the email is changed
     * @param event
     */
    handleChange(event) {

        this.setState({email: event.target.value, validEmail: Validator.isEmailValid(event.target.value)},
            () => {
                if (this.state.validEmail) {

                    if(!this.state.isForPasswordReset) {
                        Validator.isEmailAvailable(this.state.email,
                            (returned)=> {
                                this.setState({emailAvailable: returned});
                                // Verifies if username is available
                                this.props.updateParent(this.state);
                                return this.state;
                            })
                    }
                    else
                    {
                        this.props.updateParent(this.state);
                        return this.state;
                    }
                }
                else {
                    this.props.updateParent(this.state);
                }
            }
        ); // This has a callback to evaluate the warning. If we don't use a callback, is not going to read the
        // last character while we are checking if they are equal or not
    }

    // Render the form group
    render() {
        return (
            <div>
                <Row>
                    <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                        <Label for="email">
                            * <Translate id="register.email"/>
                        </Label>
                        <Input disabled={this.state.disabled} value={this.state.email} type="email" name="email"
                               id="email"
                               onChange={this.handleChange}/>
                        <br/>
                        {
                            !this.state.validEmail || !this.state.emailAvailable ?
                                <div>
                                    <Alert color="danger" isOpen={!this.state.validEmail}>
                                        <Translate id="register.email-error"/>
                                    </Alert>
                                    <Alert color="danger" isOpen={!this.state.emailAvailable}>
                                        <Translate id="register.email-availability-error"/>
                                    </Alert>
                                </div> : null
                        }
                    </Col>
                </Row>
            </div>
        )
    };
}

export default FormGroupEmail;